import React from 'react'
import { Alert } from 'react-bootstrap'
import { COLORS } from '../../constants/colors';

function WelcomeMessage({ name, addresses = [], cards = [] }) {
    // Check if user has at least one address and one card
    const hasAddress = addresses && addresses.length > 0;
    const hasCard = cards && cards.length > 0;
    const isProfileComplete = hasAddress && hasCard;

    // Define colors
    const plum = COLORS.PLUM;
    const warmConcrete = COLORS.WARM_CONCRETE;

    const customStyle = {
        backgroundColor: warmConcrete,
        color: plum,
        border: `1px solid ${plum}`,
        borderRadius: '0.375rem'
    };

    return (
        <Alert className="mb-4" style={customStyle}>
            <h4 className="alert-heading">Welcome to Pigeon Auction, {name || 'User'}!</h4>
            <p>
                Thank you for being apart of our platform. We're excited to have you as part of our community.
            </p>
            <hr style={{ borderColor: plum, opacity: 0.2 }} />
            {!isProfileComplete ? (
                <p className="mb-0">
                    IMPORTANT: To get started with bidding, please complete your profile by adding your address, mobile number and bank card details. This is important to keep in touch during auctions, organising delivery of winning bids and making bids.
                </p>
            ) : (
                <p className="mb-0">
                    Your profile is complete! You're all set to participate in auctions, place bids, and make purchases on our platform.
                </p>
            )}
        </Alert>
    )
}

export default WelcomeMessage 